module.exports = __webpack_public_path__ + "static/media/vr_2.c37ff2ed.jpg";